import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { UpdateLocalPqResourceSetRequest } from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export type UseUpdateLocalPqResourceSetMutationParams = {
  resourceSetId: string
}

export function useUpdateLocalPqResourceSetMutation(
  params: UseUpdateLocalPqResourceSetMutationParams,
  options?: UseMutationOptions<void, UpdateLocalPqResourceSetRequest>,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (request: UpdateLocalPqResourceSetRequest) => pqClient.updateResourceSet(params.resourceSetId, request),
  })

  return { updateResourceSet: mutateAsync, ...mutationResult }
}
